import {
    NoteIcon,
    PersonIcon,
    PlusIcon,
    SyncIcon,
    TrashIcon,
    UndoIcon
} from "@primer/octicons-react";
import { Box, Checkbox } from '@primer/react';

import DataGrid, {
    Column,
    Selection
} from 'devextreme-react/data-grid';
import Toolbar, { Item } from "devextreme-react/toolbar";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Transition } from 'semantic-ui-react';
import { hachToanCongNoApi } from "../../../../api/hachToanCongNopApi";
import { hocSinhApi } from "../../../../api/hocSinhApi";
import { AnimationConfirm } from '../../../../components/confirm';
import Button from '../../../../components/ui/button';
import { useCommonContext } from '../../../../contexts/common';
import { PageBaseStatus } from '../../../../models/pageBaseStatus';
import { sf_hachtoan_congno, sf_hachtoan_congno_viewmodel } from "../../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import { ts_hocsinh_viewmodel } from "../../../../models/response/hocsinh/ts_hocsinh";
import {
    changeHachToanCongNoSelectionIds, closeHachToanCongNoDeleteConfirm, closeHachToanCongNoDetailModal, closeHachToanCongNoRefundConfirm, deleteHachToanCongNoStart,
    refundHachToanCongNoStart, saveHachToanCongNoStart,
    showHachToanCongNoDeleteConfirm, showHachToanCongNoDetailModal,
    showHachToanCongNoRefundConfirm
} from '../../../../state/actions/hachToanCongNoActions';
import { RootState } from '../../../../state/reducers';
import { DetailQuyetToanModal } from "./DetailQuyetToanModal";
import DataTable from "../../../../components/ui/data-table";
import Text from "../../../../components/ui/text";
import { HocSinhRender, Infomation } from "../../../../components/hoc-sinh/HocSinhRender";
type QuyetToanHocSinhProps = {
    ts_hocsinh_id: number,
}
const QuyetToanHocSinh = (props: QuyetToanHocSinhProps) => {
    const { createUUID, checkAccesiableTo, getDataGridStorageKey } = useCommonContext();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [danhSachQuyetToanSelectedIds, setDanhSachQuyetToanSelectedIds] = useState<number[]>([]);

    const state = useSelector((x: RootState) => x.hachToan)
    const { nam_hoc } = useSelector((x: RootState) => x.common);
    const [hoanPhiTypeId, setHoanPhiTypeId] = useState<number>(-1);
    const [sf_hachtoan_congno_viewmodel, set_sf_hachtoan_congno_viewmodel] = useState<sf_hachtoan_congno_viewmodel[]>([])
    const [ts_hocsinh_viewmodel, set_ts_hocsinh_viewmodel] = useState<ts_hocsinh_viewmodel>()

    const navigate = useNavigate();
    const { status,
        //filter,
        sf_hachtoan_congno_selected_ids,
        sf_hachtoan_congno_editing,
        is_show_detail_modal,
        is_show_delete_confirm,
        is_show_import_modal,
        is_show_refund_confirm

    } = state;

    const dataSource = useMemo(() => {
        return sf_hachtoan_congno_viewmodel.filter(x => hoanPhiTypeId == -1 || hoanPhiTypeId == x.sf_hoanphi_type_id);
    }, [hoanPhiTypeId, sf_hachtoan_congno_viewmodel])

    const grid = useRef<any>();
    const dataGridStateStorageKey = getDataGridStorageKey("hachtoan")
    const handleReload = async () => {
        setIsLoading(true)
        const res = await hachToanCongNoApi.select_all_by_hocsinh({ ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: nam_hoc })
        if (res.is_success) {
            set_sf_hachtoan_congno_viewmodel(res.data)
        }
        setIsLoading(false)
    }
    const handleReloadHocSinh = async () => {
        setIsLoading(true)
        const res = await hocSinhApi.selectByIdNamHoc({ ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: nam_hoc })
        if (res.is_success) {
            set_ts_hocsinh_viewmodel(res.data)
        }
        setIsLoading(false)
    }
    useEffect(() => {
        if (status && status === PageBaseStatus.is_need_reload)
            handleReload();
    }, [status])
    useEffect(() => {
        handleReload();
        handleReloadHocSinh();
    }, [])

    const handleRefresh = () => {
        handleReload();
        handleReloadHocSinh();
        onSelectionChanged([])
        setDanhSachQuyetToanSelectedIds([])
    }

    const handleCloseDeleteConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoDeleteConfirm())
    }, [])
    const handleCloseRefundConfirm = useCallback(() => {
        dispatch(closeHachToanCongNoRefundConfirm())
    }, [])
    const handleShowDeleteConfirm = useCallback(() => {
        dispatch(showHachToanCongNoDeleteConfirm())
    }, [])
    const handleShowRefundConfirm = useCallback(() => {
        dispatch(showHachToanCongNoRefundConfirm())
    }, [])
    const handleConfirmRefund = useCallback(() => {
        dispatch(refundHachToanCongNoStart(sf_hachtoan_congno_selected_ids))
    }, [sf_hachtoan_congno_selected_ids]);

    const handleBtnEditClicked = (data: sf_hachtoan_congno_viewmodel) => {
        dispatch(showHachToanCongNoDetailModal(data));
    }
    const onSelectionChanged = useCallback((selectedRowKeys: number[]) => {
        dispatch(changeHachToanCongNoSelectionIds(selectedRowKeys))
    }, [])
    const handleConfirmDelete = useCallback(() => {
        dispatch(deleteHachToanCongNoStart(sf_hachtoan_congno_selected_ids))
    }, [sf_hachtoan_congno_selected_ids]);

    const handleCloseDetailModal = useCallback(() => {
        dispatch(closeHachToanCongNoDetailModal())
    }, [])
    const handleSubmitDetailModal = useCallback((data: sf_hachtoan_congno) => {
        dispatch(saveHachToanCongNoStart(data))
    }, [])
    return (
        <React.Fragment>
            <Box sx={{ p: 1 }}>
                <Transition animation="scale"
                    visible={true}
                    duration={100}
                    transitionOnMount={true}>
                    <Box>
                        <Box sx={{ m: 1 }}>
                            <DataTable
                                titleComponent={<Text text="Danh sách quyết toán" sx={{ fontSize: 16, fontWeight: 600 }} />}
                                data={dataSource}
                                emptyComponent={<Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        minHeight: "60vh",
                                        textAlign: "center"
                                    }}
                                >
                                    <img
                                        src="https://true-north-school.s3.cloudfly.vn/fee/datagrid_empty"
                                        alt="Không có dữ liệu"
                                        style={{ width: "60px", height: "60px", marginBottom: "5px" }}
                                    />
                                    <Box sx={{ fontSize: "13px", fontWeight: "400", color: "#8C8C8C" }}>
                                        Chưa có dữ liệu quyết toán
                                    </Box>
                                </Box>
                                }
                                selection={{
                                    mode: "multiple",
                                    keyExpr: "id",
                                    selectedRowKeys: danhSachQuyetToanSelectedIds,
                                    onSelectionChanged(keys) {
                                        setDanhSachQuyetToanSelectedIds(keys)
                                    },
                                }}
                                searchEnable
                                filterRow={{
                                    enable: true
                                }}
                                actionComponent={
                                    <Box sx={{
                                        display: "flex"
                                    }}>
                                        <Button
                                            text="Làm mới"
                                            leadingVisual={SyncIcon}
                                            variant="default"
                                            sx={{ ml: 2 }}
                                            size="small"
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                            onClick={handleRefresh}
                                        />
                                        <Button sx={{ ml: 2 }}
                                            disabled={danhSachQuyetToanSelectedIds.length === 0}
                                            text="Hoàn trả Phụ huynh"
                                            leadingVisual={UndoIcon}
                                            variant="primary"
                                            size="small"
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                            onClick={handleShowRefundConfirm}
                                        />
                                        <Button sx={{ ml: 2 }}
                                            disabled={danhSachQuyetToanSelectedIds.length === 0}
                                            text="Xóa quyết toán"
                                            leadingVisual={TrashIcon}
                                            variant="danger"
                                            size="small"
                                            isLoading={state.status === PageBaseStatus.is_loading}
                                            onClick={handleShowDeleteConfirm}
                                        />
                                    </Box>
                                }
                                columns={[
                                    {
                                        caption: "#",
                                        id: "edit",
                                        width: "50px",
                                        align: "center",
                                        isAllowFocus: false,
                                        cellRender: (data: any) => {
                                            if (data?.is_da_thanh_toan) {
                                                return <></>;
                                            }
                                            return (
                                                <a id={`btnEdit${data.id}`} style={{ cursor: "pointer", color: "#3c22ff" }}>
                                                    <i onClick={() => handleBtnEditClicked(data)} className="cmd-edit-icon fas fa-edit"></i>
                                                </a>
                                            );
                                        },
                                    },
                                    {
                                        dataField: "ho_ten",
                                        caption: 'Học sinh',
                                        width: '200px',
                                        fixed: true,
                                        cellRender: (data: any) => {
                                            const infos: Infomation[] = [
                                                { title: '', data: data.ho_ten, icon: <PersonIcon size={14} />, fontWeight: "500" },
                                                { title: '', data: data.ma_hs, icon: <NoteIcon size={14} /> },
                                            ];
                                            return (
                                                <HocSinhRender infors={infos} />
                                            )
                                        },
                                    },
                                    // {
                                    //     caption: "Mã HS",
                                    //     id: "ma_hs",
                                    //     dataField: "ma_hs",
                                    //     isAllowFocus: false,
                                    // },
                                    // {
                                    //     caption: "Họ tên",
                                    //     id: "ho_ten",
                                    //     dataField: "ho_ten",
                                    //     isAllowFocus: false,
                                    // },
                                    {
                                        caption: "Tên khối",
                                        id: "ten_khoi",
                                        width: '150px',
                                        dataField: "ten_khoi",
                                        isAllowFocus: false,
                                    },
                                    {
                                        caption: "Tên lớp",
                                        width: '100px',
                                        id: "ten_lop",
                                        dataField: "ten_lop",
                                        isAllowFocus: false,
                                    },
                                    {
                                        caption: "Nội dung",
                                        id: "noi_dung",
                                        dataField: "noi_dung",
                                        isAllowFocus: false,
                                    },
                                    {
                                        caption: "Tổng tiền",
                                        id: "tong_tien",
                                        dataField: "tong_tien",
                                        width: 120,
                                        cellRender: (data: any) => (
                                            <div style={{ whiteSpace: "pre-line", textAlign: 'right' }}>{data.tong_tien.toLocaleString()}</div>
                                        ),
                                    },
                                    {
                                        caption: "Loại",
                                        id: "is_hoan_tra",
                                        width: '100px',
                                        isAllowFocus: false,
                                        cellRender: (data: any) => (
                                            <div>{data?.data?.is_hoan_tra ? "Hoàn trả" : "Thu bổ sung"}</div>
                                        ),
                                    },
                                    {
                                        caption: "Đã thanh toán",
                                        id: "is_da_thanh_toan",
                                        dataField: "is_da_thanh_toan",
                                        width: '100px',
                                        isAllowFocus: false,
                                        cellRender: (data: any) => (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Checkbox
                                                    checked={data.is_da_thanh_toan === true}
                                                    aria-label="Kích hoạt"
                                                />
                                            </div>
                                        ),
                                    },
                                    {
                                        caption: "Hoàn trả PH",
                                        id: "is_hoantra_phuhuynh",
                                        width: '100px',
                                        dataField: "is_hoantra_phuhuynh",
                                        isAllowFocus: false,
                                        cellRender: (data: any) => (
                                            <div style={{ display: "flex", justifyContent: "center" }}>
                                                <Checkbox
                                                    checked={data.is_hoantra_phuhuynh === true}
                                                    aria-label="Hoàn trả PH"
                                                />
                                            </div>
                                        ),
                                    },
                                ]}
                            />
                            {is_show_detail_modal && <DetailQuyetToanModal
                                sf_hachtoan_congno={sf_hachtoan_congno_editing}
                                onClose={handleCloseDetailModal}
                                onSubmit={handleSubmitDetailModal}
                                is_saving={status === PageBaseStatus.is_saving}
                                nam_hoc={nam_hoc}
                                title={`${sf_hachtoan_congno_editing ? "Sửa " : "Thêm mới "} quyết toán`}
                                animationOf={sf_hachtoan_congno_editing ? `#btnEdit${sf_hachtoan_congno_editing.id}` : "#btnInsert"}
                                dm_truong_id={ts_hocsinh_viewmodel?.dm_truong_id}
                                ts_hocsinh={ts_hocsinh_viewmodel}

                            />
                            }
                        </Box>

                    </Box>
                </Transition>
                {is_show_delete_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseDeleteConfirm}
                        onConfirmed={handleConfirmDelete}
                        text={`Bạn có chắc chắn muốn xóa ${danhSachQuyetToanSelectedIds.length} khoản hạch toán đã chọn ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không xóa"
                        text_confirm_button="Tiếp tục xóa"
                        type='danger'
                        animationOf='#btnDelete'

                    />
                }
                {is_show_refund_confirm &&
                    <AnimationConfirm
                        onClose={handleCloseRefundConfirm}
                        onConfirmed={handleConfirmRefund}
                        text={`Bạn có chắc chắn muốn cập nhật ${danhSachQuyetToanSelectedIds.length} khoản hạch toán đã chọn thành Hoàn trả PH ?`}
                        is_saving={status === PageBaseStatus.is_deleting}
                        text_close_button="Không"
                        text_confirm_button="Tiếp tục"
                        type='success'
                        animationOf='#btnRefund'

                    />
                }
            </Box>
        </React.Fragment >
    );
}
export default QuyetToanHocSinh;